import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router";
import { HR_EMPLOYEES_PAGE_ROUTE, PROFILE_PAGE_ROUTE } from "@/shared/utils";
import { AuthProvider } from "../auth";
import PrivateLayout from "../layout/PrivateLayout";
import PublicLayout from "../layout/PublicLayout";
import { ErrorBoundary } from "./ErrorBoundary";
import PermissionProtectedRoute from "./PermissionProtectedRoute";
import PublicRoute from "./PublicRoute";
import { privateRoutes, publicRoutes } from "./routes";


export function AppRouter() {
  const location = useLocation();

  useEffect(function scrollToTopOnRouteChange() {
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return (
    <ErrorBoundary resetKey={location.pathname}>
      <Routes>
        <Route element={<PublicLayout />}>
          {publicRoutes.filter((route) => route.enabled !== false).map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <PublicRoute alwaysAccessible={route.alwaysAccessible}>
                  <route.element />
                </PublicRoute>
              }
            />
          ))}
        </Route>

        <Route
          path="/"
          element={
            <AuthProvider>
              <PermissionProtectedRoute>
                <PrivateLayout />
              </PermissionProtectedRoute>
            </AuthProvider>
          }>
          <Route index element={<Navigate to={PROFILE_PAGE_ROUTE} replace />} />
          {privateRoutes.filter((route) => route.enabled !== false).map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <PermissionProtectedRoute
                  requiredPermissions={route.requiredPermissions}
                  requiredRoles={route.requiredRoles}
                >
                  <route.element />
                </PermissionProtectedRoute>
              }
            />
          ))}
          <Route path="/hr/volunteers" element={<Navigate to="/projects/volunteers" replace />} />
          <Route path="*" element={<Navigate to={HR_EMPLOYEES_PAGE_ROUTE} replace />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}

